import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
var DefaultStyle = {
// flex: 1,
};
export var ListItemDecorator = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, style = _a.style, restProps = __rest(_a, ["children", "className", "style"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ className: classNames(classPrefix + "-list__item-decorator", className), style: __assign(__assign({}, DefaultStyle), style), ref: ref }, restProps), children));
});
ListItemDecorator.displayName = "ListItemDecorator";
//# sourceMappingURL=ListItemDecorator.js.map